import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-unknown-route',
	templateUrl: './unknown-route.component.html',
	styleUrls: ['./unknown-route.component.scss']
})
export class UnknownRouteComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
